export const OtherSamplesAlertsPageInfo = () => {
  return (
    <>
        This shows examples of how to use alerts and confirm boxes from the library.<br /><br />
        Your main app component needs to be wrapped in a SisLibraryProviders context.<br />
        Use the <i>useAlerts</i> react hook.<br />
        You can change the OK and Cancel button text as well (as shown in the examples).<br />
        You can also use html instead of text for styling the title and text. (also as shown in the examples).
    </>
  )
}
